import { connect } from "react-redux";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import packageJson from '../../package.json';

import Button from "./button";
import Form from "./form";

import { formatDocumentType, formatVoucher } from "../helpers/helpers";
import { getVouchers } from "../api/services";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { FormInitial } from "../helpers/interfaces";
import { initialSchema } from "../helpers/validations";
import { useSearchParams } from "react-router-dom";
import { Bounce, toast, ToastContainer } from "react-toastify";

const Section = (props: any) => {
  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(initialSchema),
    mode: "onChange",
  });
  const [searchParams] = useSearchParams();
  const [documento, voucher] = [
    searchParams.get("documento") ? searchParams.get("documento") : localStorage.getItem("documento") ? localStorage.getItem("documento") : "",
    searchParams.get("voucher") ? searchParams.get("voucher") : localStorage.getItem("voucher") ? localStorage.getItem("voucher") : "",
  ];
  
const versaoApp = packageJson.version;

  const whitelabel = props.whitelabel;
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [title, setTitle] = useState("");
  const [idVoucher, setIdVoucher] = useState("");
  const [countDocument, setCountDocument] = useState(0);
  const [countVoucher, setCountVoucher] = useState(0);
  const [requestBody, setRequestBody] = useState<FormInitial>({
    vouch_dmtp_documento: documento && documento.length > 11 ? "J" : "F",
    vouch_binu_documento: documento ? documento.toUpperCase() : "",
    vouch_vcnm_voucher: voucher ? voucher.toUpperCase() : "",
  });

  const [dataVoucher, setDataVoucher] = useState<any>(null);

  // Estados para inserir o Formulário via Portal mantendo o layout original do HTML injetado
  const [HTMLFinalWithAnchor, setHTMLFinalWithAnchor] = useState<string>("");
  const [domReady, setDomReady] = useState(false);

  // Tratamento e limpeza da String HTML convertendo os estilos JSX
  useEffect(() => {
    if (props.layout?.ivcla_txds_htmlcoverlogin) {
      // limpar a string HTML para corrigir os estilos JSX e variáveis CSS
      let rawHtml = props.layout.ivcla_txds_htmlcoverlogin;

      let htmlTratado = rawHtml
        .replace(/"--color-background-menu"/g, '"var(--color-background-menu)"')
        .replace(/"--color-primaria"/g, '"var(--color-primary)"');

      let htmlCorrected = htmlTratado.replace(
        /style=\{\{([^}]+)\}\}/g,
        (match: string, conteudoObjeto: string) => {
          const propriedades = conteudoObjeto.split(
            /,(?=(?:(?:[^"]*"){2})*[^"]*$)/,
          );
          const estilosLimpos = propriedades
            .map((prop: string) => {
              let [chave, valor] = prop.split(/:(.+)/);
              if (!chave || !valor) return "";

              chave = chave.trim().replace(/['"]/g, "");
              valor = valor.trim().replace(/['"]/g, "");

              const chaveCss = chave.replace(/([A-Z])/g, "-$1").toLowerCase();
              return `${chaveCss}:${valor}`;
            })
            .filter(Boolean)
            .join(";");

          return `style="${estilosLimpos};"`;
        },
      );

      // Substituir a âncora @@@FRONTEND_FORM_INPUT@@@ pelo espaço onde o formulário será injetado via Portal
      let finalString = htmlCorrected.replace(
        "@@@FRONTEND_FORM_INPUT@@@",
        '<div id="espaco-do-form"></div>',
      );

      finalString = finalString.replace(
        "@@@FRONTEND_VERSAO_APP@@@",
        '<div id="versao"></div>',
      );

      setHTMLFinalWithAnchor(finalString);
    }
  }, [props.layout]);

  useEffect(() => {
    if (HTMLFinalWithAnchor && document.getElementById("espaco-do-form") && document.getElementById("versao")) {
      setDomReady(true);
    } else {
      setDomReady(false);
    }
  }, [HTMLFinalWithAnchor]);

  useEffect(() => {
    if (documento && voucher) {
      localStorage.setItem("documento", documento);
      localStorage.setItem("voucher", voucher);
      window.history.replaceState(null, "", window.location.pathname);
    }
    setCountDocument(18);
    setCountVoucher(13);
    if (documento) {
      setValue("document", documento, { shouldValidate: true });
      setValue("typeDocument", documento.length > 11 ? "J" : "F", {
        shouldValidate: true,
      });
    }
    if (voucher) {
      setValue("voucher", voucher, { shouldValidate: true });
    }
  }, []);

  const handleDocument = (e: any) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9]/g, "");
    value = value.toUpperCase();
    let typeDocument = value.length > 11 ? "J" : "F";

    setRequestBody((prev: FormInitial) => ({
      ...prev,
      vouch_binu_documento: value,
      vouch_dmtp_documento: typeDocument,
    }));

    setValue("document", value, { shouldValidate: true });
    setValue("typeDocument", typeDocument, { shouldValidate: true });
  };

  const handleVoucher = (e: any) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9]/g, "");
    value = value.toUpperCase();
    setValue("voucher", value, { shouldValidate: true });
    setRequestBody((prev: FormInitial) => ({
      ...prev,
      vouch_vcnm_voucher: value,
    }));
  };

  const onSubmitForm = () => {
    // console.log("Enviando formulário com dados:", {
    //   urlApi: props.whitelabel.urlApi,
    //   accessToken: props.token.access_token,
    //   voucher: requestBody.vouch_vcnm_voucher,
    //   documentType: requestBody.vouch_dmtp_documento,
    //   documento: requestBody.vouch_binu_documento,
    // });
    setLoading(true);
    getVouchers(
      props.whitelabel.urlApi,
      props.token.access_token,
      requestBody.vouch_vcnm_voucher,
      requestBody.vouch_dmtp_documento,
      requestBody.vouch_binu_documento,
    ).then((response: any) => {
      try {
        // console.log("Resposta da API:", response);
        if (response.status.codigo === 0) {
          setTitle(requestBody.vouch_vcnm_voucher);
          setDataVoucher(response.detalhe);
          setError(false)
          tooglePopup();
        } else {
          toast.dismiss(); 
          setError(true);
          setErrorMessage(response.status.mensagem || "Erro ao buscar cupom. Tente novamente mais tarde.");
          toast.warn(response.status.mensagem || "Erro ao buscar cupom. Tente novamente mais tarde.", {
            toastId: Date.now().toString(),
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(true);
        setErrorMessage("Erro ao buscar cupom. Tente novamente mais tarde.");
        toast.dismiss(); 
        toast.error("Erro ao buscar cupom. Tente novamente mais tarde.", {
          toastId: Date.now().toString(),
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        console.log("Erro ao buscar cupom: ", error);
      }
    });
  };

  const tooglePopup = () => {
    setIsOpen(!isOpen);
  };

  const renderForm = () => {
    return (
      <div className="">
        <ToastContainer style={{ zIndex: 100 }} limit={3} />
        <form
          onSubmit={handleSubmit(onSubmitForm)}
          className="w-full mx-auto z-50"
        >
          <div className="flex flex-col gap-3">
            <input
              type="text"
              placeholder="Digite o Documento (CPF ou CNPJ)"
              onChange={handleDocument}
              value={formatDocumentType(
                requestBody.vouch_binu_documento,
                requestBody.vouch_dmtp_documento,
              )}
              maxLength={countDocument}
              className="input rounded-md bg-slate-100 border border-slate-200 /*focus:border-green-price*/ /*focus:ring-2*/ /*focus:ring-green-price*/ px-4 py-3 text-lg transition duration-150"
            />

            {typeof errors.document?.message === "string" ? (
              <span className="text-red-500 text-xs">
                {errors.document.message}
              </span>
            ) : (
              <span className="text-transparent text-xs">-</span>
            )}
            <input
              type="text"
              placeholder="Digite o Número do Cupom"
              onChange={handleVoucher}
              maxLength={countVoucher}
              value={formatVoucher(requestBody.vouch_vcnm_voucher)}
              className="input rounded-md bg-slate-100 border border-slate-200 /*focus:border-green-price /*focus:ring-2*/ /*focus:ring-green-price*/ px-4 py-3 text-lg transition duration-150"
            />
            {typeof errors.voucher?.message === "string" ? (
              <span className="text-red-500 text-xs">
                {errors.voucher.message}
              </span>
            ) : (
              <span className="text-transparent text-xs">-</span>
            )}
            <Button
              loading={loading}
              name="Validar"
              className="w-full bg-[var(--color-secundaria)] text-[var(--color-primaria)] font-bold py-3 mt-2 rounded-xl text-lg shadow-md hover:bg-[var(--color-botao-submit)] transition"
            />
            {error ? (
              <span className="text-red-500 text-xs text-center font-semibold">{errorMessage}</span>
            ) : (
              <span className="text-transparent text-xs">-</span>
            )}
          </div>
        </form>
      </div>
    );
  };

  const renderAppVersion = () => {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full">
        <p className="text-sm">
          Versão {versaoApp}
        </p>
      </div>
    );
  }

  // Renderização condicional unificada baseada nas seções
  switch (props.type) {
    case "first":
      return (
        <>
          {isOpen && (
            <Form
              HandleClose={tooglePopup}
              content={
                <div>
                  <h2 style={{ color: `var(--color-primaria)` }}>Texto</h2>
                  <p style={{ color: `var(--color-primaria)` }}>
                    Formulário {idVoucher}
                  </p>
                </div>
              }
              title={title}
              voucher={requestBody.vouch_vcnm_voucher}
              dataVoucher={dataVoucher}
              className="z-50"
            />
          )}

          <div className="bg-[#e1e9fe] text-black font-sans leading-relaxed m-0 p-0 box-border antialiased">
            {/* 1. Injeta a string HTML processada pelo useEffect */}
            <div dangerouslySetInnerHTML={{ __html: HTMLFinalWithAnchor }} />

            {/* 2. O Portal lança o formulário vivo para dentro da div injetada mantendo o grid */}
            {domReady &&
              document.getElementById("espaco-do-form") &&
              createPortal(
                renderForm(),
                document.getElementById("espaco-do-form")!,
              )}
            {/* 3. O Portal lança a versão do app para dentro da div injetada mantendo o grid */}
            {domReady &&
              document.getElementById("versao") &&
              createPortal(
                renderAppVersion(),
                document.getElementById("versao")!,
              )}
          </div>
        </>
      );

    default:
      return <></>;
  }
};

function mapDispatchToProps(dispatch: any) {
  return {};
}

function mapStateToProps(state: any) {
  return {
    whitelabel: state.whiteLabel,
    token: state.session,
    layout: state.layout,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Section);
